/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_History_EmptyInputs */

const en_admin_ai_chat_history_empty = /** @type {(inputs: Admin_Ai_Chat_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No past chats yet`)
};

const de_admin_ai_chat_history_empty = /** @type {(inputs: Admin_Ai_Chat_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine früheren Chats`)
};

const es_admin_ai_chat_history_empty = /** @type {(inputs: Admin_Ai_Chat_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay chats anteriores`)
};

const fr_admin_ai_chat_history_empty = /** @type {(inputs: Admin_Ai_Chat_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun chat précédent`)
};

const nl_admin_ai_chat_history_empty = /** @type {(inputs: Admin_Ai_Chat_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen eerdere chats`)
};

/** @type {(inputs: Admin_Ai_Chat_History_EmptyInputs) => LocalizedString} */
const it_admin_ai_chat_history_empty = en_admin_ai_chat_history_empty;

/** @type {(inputs: Admin_Ai_Chat_History_EmptyInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_history_empty = en_admin_ai_chat_history_empty;

/** @type {(inputs: Admin_Ai_Chat_History_EmptyInputs) => LocalizedString} */
const pl_admin_ai_chat_history_empty = en_admin_ai_chat_history_empty;

/** @type {(inputs: Admin_Ai_Chat_History_EmptyInputs) => LocalizedString} */
const hu_admin_ai_chat_history_empty = en_admin_ai_chat_history_empty;

/** @type {(inputs: Admin_Ai_Chat_History_EmptyInputs) => LocalizedString} */
const ro_admin_ai_chat_history_empty = en_admin_ai_chat_history_empty;

/**
* | output |
* | --- |
* | "No past chats yet" |
*
* @param {Admin_Ai_Chat_History_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_history_empty = /** @type {((inputs?: Admin_Ai_Chat_History_EmptyInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_History_EmptyInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_history_empty(inputs)
	if (locale === "de") return de_admin_ai_chat_history_empty(inputs)
	if (locale === "es") return es_admin_ai_chat_history_empty(inputs)
	if (locale === "fr") return fr_admin_ai_chat_history_empty(inputs)
	if (locale === "nl") return nl_admin_ai_chat_history_empty(inputs)
	if (locale === "it") return it_admin_ai_chat_history_empty(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_history_empty(inputs)
	if (locale === "pl") return pl_admin_ai_chat_history_empty(inputs)
	if (locale === "hu") return hu_admin_ai_chat_history_empty(inputs)
	return ro_admin_ai_chat_history_empty(inputs)
});
export { admin_ai_chat_history_empty as "admin.ai_chat.history_empty" }